import { render, staticRenderFns } from "./MediaComponent.vue?vue&type=template&id=d468005c&scoped=true&"
import script from "./MediaComponent.vue?vue&type=script&lang=js&"
export * from "./MediaComponent.vue?vue&type=script&lang=js&"
import style0 from "./MediaComponent.vue?vue&type=style&index=0&id=d468005c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d468005c",
  null
  
)

export default component.exports